import { ArticleParagraph1, ArticleParagraph2, ArticleParagraph3 } from '@cian/ui-kit';
import { COMMON_COMPONENT_PROPS } from '../const';

export const articleParagraphs = {
  ArticleParagraph1: {
    ...COMMON_COMPONENT_PROPS,
    id: 'articleParagraph1',
    component: ArticleParagraph1,
    tagName: 'articleparagraph1',
    block: {
      label: 'ArticleParagraph1',
      category: 'Article Typography',
      content: '<ArticleParagraph1>ArticleParagraph1</ArticleParagraph1>',
    },
  },

  ArticleParagraph2: {
    ...COMMON_COMPONENT_PROPS,
    id: 'articleParagraph2',
    component: ArticleParagraph2,
    tagName: 'articleparagraph2',
    block: {
      label: 'ArticleParagraph2',
      category: 'Article Typography',
      content: '<ArticleParagraph2>ArticleParagraph2</ArticleParagraph2>',
    },
  },

  ArticleParagraph3: {
    ...COMMON_COMPONENT_PROPS,
    id: 'articleParagraph3',
    component: ArticleParagraph3,
    tagName: 'articleparagraph3',
    block: {
      label: 'ArticleParagraph3',
      category: 'Article Typography',
      content: '<ArticleParagraph3>ArticleParagraph3</ArticleParagraph3>',
    },
  },
};
